export default {"src":"/_next/static/media/badges-fall.747eb18e.svg","height":127,"width":98,"blurWidth":0,"blurHeight":0};